import {
  FETCH_PM_IWO_LIST_REQUEST,
  FETCH_PM_IWO_LIST_SUCCESS,
  FETCH_PM_IWO_LIST_FAILURE,
  INSERT_PM_FRAME_REQUEST,
  INSERT_PM_FRAME_SUCCESS,
  INSERT_PM_FRAME_FAILURE,
  FETCH_PM_FRAME_LIST_REQUEST,
  FETCH_PM_FRAME_LIST_SUCCESS,
  FETCH_PM_FRAME_LIST_FAILURE,
  INSERT_PM_DAILY_REMARK_REQUEST,
  INSERT_PM_DAILY_REMARK_SUCCESS,
  INSERT_PM_DAILY_REMARK_FAILURE,
  UPDATE_PM_COMPLETION_REQUEST,
  UPDATE_PM_COMPLETION_SUCCESS,
  UPDATE_PM_COMPLETION_FAILURE,
  UPDATE_PM_FRAME_REQUEST,
  UPDATE_PM_FRAME_SUCCESS,
  UPDATE_PM_FRAME_FAILURE,
  FETCH_PM_DELAY_REASONS_REQUEST,
  FETCH_PM_DELAY_REASONS_SUCCESS,
  FETCH_PM_DELAY_REASONS_FAILURE,
  DELETE_PM_FRAME_REQUEST,
  DELETE_PM_FRAME_SUCCESS,
  DELETE_PM_FRAME_FAILURE,
  FETCH_PM_IWO_FRAMES_REQUEST,
  FETCH_PM_IWO_FRAMES_SUCCESS,
  FETCH_PM_IWO_FRAMES_FAILURE,
} from "../constants/ProductionMonitorConstants";

import ProductionMonitorService from "../service/ProductionMonitorService";

// Backend sends the error text in Result (e.g. StatusCode 409, Result: "Part No already exists for this IWO: 286")
const apiMessage = (data) =>
  data?.Message ||
  (typeof data?.Result === "string" && data.Result) ||
  data?.message ||
  "";

// Fetch IWO list for the IWO dropdown
export const fetchPmIwoList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_IWO_LIST_REQUEST });

    const response = await ProductionMonitorService.GetIwoList();

    dispatch({
      type: FETCH_PM_IWO_LIST_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_IWO_LIST_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch IWO list",
    });
  }
};

// Insert frame with part numbers
// returns { success: true } or { success: false, message }
export const insertPmFrame = (payload) => async (dispatch) => {
  try {
    dispatch({ type: INSERT_PM_FRAME_REQUEST });

    const response = await ProductionMonitorService.InsertFrame(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to insert frame";
      dispatch({ type: INSERT_PM_FRAME_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: INSERT_PM_FRAME_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to insert frame";

    dispatch({ type: INSERT_PM_FRAME_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Fetch all frames (with parts + daily remarks) for the Daily Remark page
export const fetchPmFrameList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_FRAME_LIST_REQUEST });

    const response = await ProductionMonitorService.GetFrameDetails();

    dispatch({
      type: FETCH_PM_FRAME_LIST_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_FRAME_LIST_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch frame list",
    });
  }
};

// Insert daily remark for a frame
// returns { success: true } or { success: false, message }
export const insertPmDailyRemark = (payload) => async (dispatch) => {
  try {
    dispatch({ type: INSERT_PM_DAILY_REMARK_REQUEST });

    const response = await ProductionMonitorService.InsertDailyRemark(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to save daily remark";
      dispatch({ type: INSERT_PM_DAILY_REMARK_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: INSERT_PM_DAILY_REMARK_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to save daily remark";

    dispatch({ type: INSERT_PM_DAILY_REMARK_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Update physical completion (%) of a frame
// returns { success: true } or { success: false, message }
export const updatePmPhysicalCompletion = (payload) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PM_COMPLETION_REQUEST });

    const response = await ProductionMonitorService.UpdatePhysicalCompletion(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to update physical completion";
      dispatch({ type: UPDATE_PM_COMPLETION_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: UPDATE_PM_COMPLETION_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to update physical completion";

    dispatch({ type: UPDATE_PM_COMPLETION_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Update a frame (only changed fields are in the payload)
export const updatePmFrame = (payload) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PM_FRAME_REQUEST });

    const response = await ProductionMonitorService.UpdateFrame(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to update frame";
      dispatch({ type: UPDATE_PM_FRAME_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: UPDATE_PM_FRAME_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to update frame";

    dispatch({ type: UPDATE_PM_FRAME_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Delay reasons for daily remark (CDL + DTS dropdowns)
export const fetchPmDelayReasons = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_DELAY_REASONS_REQUEST });

    const response = await ProductionMonitorService.GetDelayReasons();

    dispatch({
      type: FETCH_PM_DELAY_REASONS_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_DELAY_REASONS_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch delay reasons",
    });
  }
};

// Delete a frame (wrongly entered)
export const deletePmFrame = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PM_FRAME_REQUEST });

    const response = await ProductionMonitorService.DeleteFrame(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to delete frame";
      dispatch({ type: DELETE_PM_FRAME_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: DELETE_PM_FRAME_SUCCESS, payload: payload.frameId });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to delete frame";

    dispatch({ type: DELETE_PM_FRAME_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Frames of the given IWO(s) - for the frame count / completed summary in Production
// (one GetFrameDetails?iwoNo=xx call per IWO)
export const fetchPmIwoFrames = (iwoNos = []) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_IWO_FRAMES_REQUEST });

    const responses = await Promise.all(iwoNos.map((iwoNo) => ProductionMonitorService.GetFrameDetails(iwoNo)));
    const frames = responses.flatMap((r) => r?.data?.Data || []);

    dispatch({ type: FETCH_PM_IWO_FRAMES_SUCCESS, payload: frames });
  } catch (error) {
    dispatch({
      type: FETCH_PM_IWO_FRAMES_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch frames",
    });
  }
};